import React, { useState } from 'react';
import { useCreateBackgroundMutation } from 'lib/api/backgrounds/useCreateBackgroundMutation';
import { useToastError } from 'lib/hooks';
import { useUploadFile } from 'lib/hooks/useUploadFile';
import { ImageUploadAndCropModal } from 'lib/components/modal/image-upload/ImageUploadAndCropModal';
import { useTranslation } from 'react-i18next';

interface IAddBackgroundModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const AddBackgroundModal = ({
  isOpen,
  onClose,
}: IAddBackgroundModalProps) => {
  const { t } = useTranslation();
  const { uploadFile } = useUploadFile();
  const { showError } = useToastError();
  const [isUploading, setIsUploading] = useState(false);

  const { mutateAsync: createBackgroundMutation, isLoading } =
    useCreateBackgroundMutation();

  const handleSaveBackground = async (croppedImageFile: File) => {
    try {
      setIsUploading(true);
      const url = await uploadFile(croppedImageFile);
      if (!url) {
        showError(t('Failed to get URL from file upload.'));
        return;
      }
      await createBackgroundMutation({
        url,
        fileName: croppedImageFile.name,
      });
      setIsUploading(false);
      onClose();
    } catch (error) {
      showError(t('Failed to create or upload background'));
      setIsUploading(false);
    }
  };

  const loading = isUploading || isLoading;

  return (
    <ImageUploadAndCropModal
      isOpen={isOpen}
      onClose={onClose}
      onSave={handleSaveBackground}
      isSaving={loading}
      headerText={t('Add A New Background')}
      saveButtonText={t('Add Background')}
      aspectRatio={16 / 9}
    />
  );
};
